export default function Comparison( value1, value2 ) {
  this.MatchTypes = {
    Boolean: 1,
    String: 2,
    Integer: 3,
    Float: 4,
    Date: 5,
    Time: 6,
    DateTime: 7,
    DataRow: 8
  };
  this.value1 = value1;
  this.value2 = value2;
};

Comparison.prototype.isMatch = function( matchType ) {

  if( this.value1 === undefined && this.value2 === undefined ) {
    return true;
  }

  if( this.value1 === undefined && this.value2 !== undefined ) {
    return false;
  }

  if( this.value1 !== undefined && this.value2 === undefined ) {
    return false;
  }
  
  let aValue;
  let bValue;
  if( matchType === this.MatchTypes.Boolean ) {
    if( typeof( this.value1 ) === "boolean" ) {
      aValue = this.value1
    } else {
      if( this.value1.lower() === 'yes' ) { aValue = true }
      if( this.value1.lower() === 'true' ) { aValue = true }
      if( this.value1.lower() === 'no' ) { aValue = false }
      if( this.value1.lower() === 'false' ) { aValue = false }
    } 
    if( typeof( this.value2 ) === "boolean" ) {
      bValue = this.value2
    } else  {
      if( this.value2.lower() === 'yes' ) { bValue = true }
      if( this.value2.lower() === 'true' ) { bValue = true }
      if( this.value2.lower() === 'no' ) { bValue = false }
      if( this.value2.lower() === 'false' ) { bValue = false }
    }
  } else if( matchType === this.MatchTypes.String ) {

    if( typeof( this.value1 ) !== 'string' ) {
      aValue = this.value1.toString( );
    } else {
      aValue = this.value1;
    }

    if( typeof( this.value2 ) === 'string' ) {
      bValue = this.value2.toString( );
    } else {
      bValue = this.value2;
    }
  } else if( matchType === this.MatchTypes.Integer ) {
    aValue = parseInt( this.value1, 10 );
    bValue = parseInt( this.value2, 10 );
  } else if( matchType === this.MatchTypes.Float ) {
    aValue = parseFloat( this.value1 );
    bValue = parseFloat( this.value2 );
  } else if( matchType === this.MatchTypes.Date) { 
    const options = { year:'numeric', month:'numeric', day:'numeric', hour:"numeric", minute:"numeric", second:"numeric" };
    aValue = new Date( this.value1 ).toLocalString('en-US',options).split(' ')[0]
    bValue = new Date( this.value2 ).toLocalString('en-US',options).split(' ')[0]
  } else if( matchType === this.MatchTypes.Time ) { 
    const options = { year:'numeric', month:'numeric', day:'numeric', hour:"numeric", minute:"numeric", second:"numeric" };
    aValue = new Date( this.value1 ).toLocalString('en-US',options).split(' ')[1]
    bValue = new Date( this.value2 ).toLocalString('en-US',options).split(' ')[1]
  } else if( matchType === this.MatchTypes.DateTime ) { 
    const options = { year:'numeric', month:'numeric', day:'numeric', hour:"numeric", minute:"numeric", second:"numeric" };
    aValue = new Date( this.value1 ).toLocalString('en-US',options)
    bValue = new Date( this.value2 ).toLocalString('en-US',options)
  } else if( matchType === this.MatchTypes.DataRow ) {
    if( typeof( this.value1 ) !== typeof( this.value2 ) ) {
      return false;
    }
    aValue = JSON.stringify(this.value1);
    bValue = JSON.stringify(this.value2);
  } else {
    aValue = this.value1;
    bValue = this.value2;
  }
  return ( aValue === bValue );
};


// WEBPACK FOOTER //
// ./src/prototypes/Comparison.js